export default __webpack_public_path__ + "static/media/MathWallet.c8223809.svg";